package app.nestbridge.feature.careteam.model

import app.nestbridge.domain.identity.model.ProfessionalServiceType
import kotlinx.serialization.Serializable
import kotlin.time.Instant

@Serializable
data class CareTeam(
    val id: String,
    val childId: String,
    val teamType: ProfessionalServiceType,
    val description: String? = null,
    val members: List<CareTeamMember> = emptyList(),
    val status: String,
    val createdAt: Instant,
    val createdBy: String,
    val modifiedAt: Instant,
    val modifiedBy: String,
) {
    companion object {
        val empty = CareTeam(
            id = "",
            childId = "",
            teamType = ProfessionalServiceType.SpeechLanguageTherapy,
            description = null,
            members = emptyList(),
            status = "Active",
            createdAt = kotlin.time.Clock.System.now(),
            createdBy = "",
            modifiedAt = kotlin.time.Clock.System.now(),
            modifiedBy = "",
        )
    }
}
